(function() {
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-behavior~=change-input]');
    if (!trigger) return;

    e.preventDefault();

    const targetType = trigger.dataset.target;
    const value = trigger.dataset.value;
    const targetInput = document.querySelector(`[data-type~="${targetType}"]`);

    if (targetInput) {
      targetInput.value = value;
      targetInput.blur();
    }

    return false;
  });
})();
